import { Link, Typography } from "@mui/material"
import { SOL, USDC } from "@renec-foundation/relend-adapter"

const locale: { [key: string]: any } = {
  base: {
    all_rights_reserved: "All rights reserved",
    relend_all_rights_reserved: "RENEC Lend all rights reserved",
  },
  header: {
    vietnamese: "Tiếng việt",
    english: "English",
    home: "Home",
    create_token: "Create Token",
    faqs: "FAQs",
    connect_wallet: "Connect wallet",
    dashboard: "Dashboard",
    liquidations: "Liquidations",
    referral: "Referral",
    docs: "Documents",
    audits: "Audits",
    tokenomic: "Tokenomic",
    staking: "Staking",
    tokenomic_link: "https://renec.org/en/blog/tokenomics-relend-token",
    audit_link: "https://renec.org/vi/blog/renec-lend-smart-contract-passes-audit",
  },
  footer: {
    about_us: "About us",
    news: "News",
    faq: "FAQ",
    career: "Careers",
    contact: "Contact",
    privacy: "Privacy policy",
    terms: "Terms of use",
  },
  seo: {
    seo_title: "RENEC Lend | Official Website",
    seo_title_dashboard: "RENEC Lend | Account Management",
    seo_title_referral: "RENEC Lend | Referral Program",
    seo_title_liquidations: "RENEC Lend | Liquidations",
    seo_title_staking: "RENEC Lend | Staking",
    seo_description: "Lending & Borrowing service with RENEC Lend. Safe & Good rate. Chance for Passive income",
    seo_description_dashboard: "Lending & Borrowing service with RENEC Lend. Good liquidity & Various token options",
    seo_description_referral:
      "Refer friends to use RENEC Lend's Borrowing & Lending service to have the opportunity to receive exclusive offers",
    seo_description_liquidations:
      "Keep track of loans being liquidated and look for opportunities to become a liquidator with attractive income",
    seo_description_staking:
      "Stake assets in the Secure Vault of RENEC Lend to add more security to the protocol and earn rewards",
  },
  home: {
    title_p1: "Smart DeFi Moves",
    title_p2: "Borrow and Lend for Dual Earnings!",
    sub_title: (
      <>
        Earn competitive yields and borrow fiat effortlessly on <span className='font-bold'>RENEC Lend</span>, the
        fastest, lowest fee, and most secure fiat lending protocol.
      </>
    ),
    get_started: "Get Started",
    become_liquidator_p1: "Become a liquidator in our pre-launch phase and discover greater profit opportunity. Only",
    become_liquidator_p2: "are available. Secure your spot and start earning now!",
    exclusive_slots: "1,000 exclusive slots",
    what_is_liquidator: "What is Liquidator?",
    liquidator: "LIQUIDATOR",
    liquidators: "LIQUIDATORS",
    registration: "REGISTRATION",
    email: "Email",
    register: "Register",
    invalid_email: "Invalid email address",
    days: "Days",
    hours: "Hours",
    minutes: "Minutes",
    seconds: "Seconds",
    why_choose_p1: "Why Choose",
    renec_land: "RENEC Lend?",
    why_choose_p2: "",
    trustworthy_protocal: "Trustworthy Protocol:",
    trustworthy_protocal_description:
      "We are backed by RENEC Foundation, ensuring the highest standards of security for your peace of mind.",
    lower_interest: "Lower Interest Rates:",
    lower_interest_description:
      "We offers the most competitive interest rates to ensure you keep more of your earnings.",
    user_focused: "User-Focused:",
    user_focused_description: "We commit to provide the best possible experience for all users.",
    simplicity: "Simplicity",
    simplicity_subtitle: "Make it accessible and user-friendly for both beginners and experts",
    economy: "Economy",
    economy_subtitle:
      "Establish significantly low interest rates and borrowing fees compared to other lending platforms",
    opportunity: "Opportunity",
    opportunity_subtitle: "Bringing a chance to be a liquidator to everyone with our liquidator program",
    join_mail: "Join our Mail list",
    im_in: "I'm in",
    email_submit_success: "Email submitted successfully",
    what_is_liquidator_tooltip:
      "A liquidator is an individual or entity that capitalizes on opportunities when other user's loans hit liquidation threshold due to market fluctuations. They repay the borrower's debt and, in return, receive a portion of the borrower's collateral at a discounted rate",
    launch_app: "Open app",
    why_choose_we: "Why choose us",
    feedback: "Feedback",
    snapshot_of_our_success: "Snapshot of our success",
    explore_analytics:
      "Renec Lend is the future of fiat lending, offering enhanced accessibility, efficiency, security, and innovation.",
    trusted_by_our_investors: "Trusted by Our Investors",
    understanding_renec_lend: "Understanding Renec Lend",
    discover_the_key_functions:
      "Discover the key functions of Renec Lend to optimize your earnings and manage assets effectively.",
    understanding_details: {
      tabs: [
        {
          title: "Supply to earn",
          description: "Provide your assets to the platform to earn interest and airdrop rewards.",
        },
        { title: "NFT voucher", description: "Get exclusive NFT voucher to reduce fee and borrow interest." },
        { title: "Relend token", description: "Join our community and shape the future of DeFi with REL token." },
        { title: "Staking", description: "Earn yields and exclusive benefits from your REL tokens." },
      ],
      details: [
        {
          title: "Supply to earn",
          description:
            "Provide assets to the protocol to earn interest and rewards. We always partner with potential projects to bring the most attractive airdrop for our users",
          items: [],
          note: "",
        },
        {
          title: "NFT voucher",
          description:
            "NFT vouchers are unique digital assets that grant holders exclusive benefits, such as reduced fees and interest rates on our DeFi lending platform. Experience the power of NFT vouchers and unlock a world of savings today.",
          items: [],
          note: "",
        },
        {
          title: "Relend token",
          description: (
            <>
              The{" "}
              <a
                href='https://solscan.io/token/9HvM3nS2eDKWxNvi8vSFXRhHA1xhDW33rt4ZA1bE1DbV'
                target='_blank'
                rel='noreferrer'
                className='text-blue-600 underline'
              >
                Relend (REL)
              </a>{" "}
              token is the governance token of our DeFi lending platform, empowering holders to shape the future of the
              protocol and get exclusive membership benefits.
            </>
          ),
          items: [],
          note: "",
        },
        {
          title: "Staking",
          description:
            "By staking Relend tokens, users can participate in governance decisions, such as proposing and voting on new features, upgrades, and changes to the platform. Additionally, stakers can earn rewards from the protocol's treasury.",
          items: [],
          note: "",
        },
      ],
    },
    why_choose_renec_lend: "Why choose Renec Lend?",
    backed_by_renec_foundation:
      "Backed by RENEC Foundation, Renec Lend offers secure lending, competitive interest rates",
    renec_lend_insights: "Renec Lend Insights",
    stay_informed_with_the_latest_news:
      "Stay informed with the latest news, tips, and updates on crypto lending. Discover how to maximize your earnings and navigate the world of decentralized finance with Renec Lend.",
    stay_updated_with_renec_lend: "Stay Updated with Renec Lend",
    join_with_your_email: "Join with your email to receive news, rewards, and more!",
    join_now: "Join now",
    enter_your_email: "Enter your email",
    discover_now: "Discover now",
    first_fiat_lending_protocol: "First Fiat Lending Protocol",
    introducing_our_revolutionary:
      "Introducing our revolutionary Fiat Lending: the first and only platform that offers secure, transparent, and accessible fiat loans.",
    lower_nterest_rates: "Lower Interest Rates",
    we_offers_the_most: "We offers the most competitive interest rates to ensure you keep more of your earnings",
    liquidity_mining_with_airdrop: "Liquidity Mining With Airdrop",
    earn_rewards_by_providing:
      "Earn rewards by providing liquidity to our pools and snag exclusive airdrops from our partners",
    total_supply: "Total supply",
    total_borrow: "Total borrow",
    unique: "Unique wallets",
    mentioned_by: "Mentioned By",
  },
  dashboard: {
    hero: {
      market_overview: "Market overview",
      renec_market: "Renec market",
      solana_market: "Solana market",
      new: "New",
      select_market: "Select Market",
      total_supply: "Total supply",
      total_borrow: "Total borrow",
      total_tvl: "Total value locked",
      total_market: "Total market",
      account_overview: "Account overview",
      net_apy: "Net APY",
      user_borrow_limit: "User borrow limit",
      liquidation_threshold: "Liquidation threshold",
      current_progress_title: "You are borrowing %s% of your total supply, or %s% of your limit",
      borrow_limit_title: "You borrow limit is at %s and is %s% of your total supply",
      liquidation_threshold_title: "Your liquidation threshold is at %s and is %s% of your total supply",
      supply_title:
        "Your total supply is %s. Supply more assets to increase your borrow limit and liquidation threshold.",
      daily_reward: "Daily reward",
      claim: "Claim now",
      borrow_at_least: "To claim daily rewards, you need to borrow at least: ",
      level_1: "LVL1. $100 for 0.1 REL/day",
      level_2: "LVL2. $200 for 0.5 REL/day",
      level_3: "LVL3. $500 for 2 REL/day",
      level_4: "LVL4. $1000 for 2.5 REL/day",
      level_5: "LVL5. For every additional $1,000, you will earn 0.5 REL",
      claim_successfully: "Claim successfully.",
      come_back_at: "Come back at ",
      left_for: "left for",
      left_for_next: "left for next",
      for_more_reward: "for more rewards",
      reward_will_be_accumulated: "Reward will be accumulated",
      errors: {
        claim_reward: "Error when claiming reward. Please contact RENEC team for more information.",
        refresh_reward: "Error when refreshing reward. Please contact RENEC team for more information.",
        fetch_bte_reward: "Error when fetching borrow rewards. Please contact RENEC team for more information.",
      },
      my_account: "My assets",
      borrow_limits: "Loan Health",
      subtitle_borrow_limits: "Borrowed percentage of your total supply",
      others: "Others assets",
      my_staking: "My staking",
      stake_and_earn: "Stake & Earn",
      total_nft_voucher: "Total NFT voucher",
      nft_view_detail: "View detail",
      nft_voucher: "vouchers",
      nft_claim: "Claim",
      title_nft_vouchers: "NFT Vouchers",
      available_to_claim_tab: (amount: number) => `Available to claim (${amount})`,
      claimed_tab: (amount: number) => `Claimed (${amount})`,
      available_to_claim: (amount: number) =>
        `(<span class="font-semibold text-neutral-900">${amount}</span> available to claim)`,
      claim_now: "Claim Now",
    },
    table: {
      asset: "Asset",
      supplied: "Supplied",
      price_change: "Price Change",
      supply: "Supply",
      market_price: "Market Price",
      supply_apy: "Supply APY",
      wallet_balance: "Wallet balance",
      earned: "Earned",
      actions: "Actions",
      borrowed: "Borrowed",
      borrow_apr: "Borrow APR",
      borrow_apy: "Borrow APY",
      interest: "Interests",
      withdraw: "Withdraw",
      borrow: "Borrow",
      repay: "Repay",
      detail: "Detail",
      my_supply: "My supply",
      my_borrow: "My borrow",
      your_borrow_limit: "Your borrow limit",
      ltv: "LTV",
      ltv_info: "LTV is a ratio that determines how much borrow power is contributed by a deposited asset.",
      empty_supply: "You haven't supply any token",
      empty_borrow: "You haven't borrow any token",
      total_supply: "Total supply",
      supplied_info: "Total asset supply and earned tokens",
      supply_apy_interest: "Supply APY",
      rewards: "rewards",
      max_reward: "Max reward: ",
      supply_reward_information: "Information about this rewards can be found",
      temp_ngn_borrow_apr_info:
        "Due to high inflation of Nigeria, the APR will be adjusted accordingly to balance the benefit of suppliers and borrowers",
      no_liquidations: "Currently there are no unhealthy positions to liquidate",
      here: "here",
      your_wallet_empty: (network: string, isRenecChain: boolean, bridgeName?: string, bridgeLink?: string) => (
        <Typography className='text-xs'>
          {isRenecChain ? (
            <>
              Your {network} wallet is empty. Purchase or transfer assets using{" "}
              <Link href={bridgeLink} target='_blank' className='font-bold' rel='noreferrer'>
                {bridgeName}
              </Link>{" "}
            </>
          ) : (
            <>
              Your {network} wallet is empty. Purchase or transfer assets or use{" "}
              <Link href={bridgeLink} target='_blank' className='font-bold' rel='noreferrer'>
                {bridgeName}
              </Link>{" "}
              to transfer your {network} assets
            </>
          )}
        </Typography>
      ),
      borrow_no_obligation: (
        <Typography className='text-xs'>To borrow you need to supply any asset to be used as collateral.</Typography>
      ),
      refresh_reward_tooltip_desc: (timeleft: string) =>
        `Your rewards will auto-refresh in ${timeleft}. Click this to trigger a manual refresh.`,
      refresh_ste_reward_successfully: "Your total reward has been updated.",
      errors: {
        fetch_ste_reward: "Error when fetching supply rewards. Please contact RENEC team for more information.",
      },
      info: {
        price_change: "Price change in the last 24 hours",
      },
      isolated: "Isolated",
      isolated_desc:
        "Isolated asset is the separated pool and will not affect to your borrow limit and liquidation risk",
    },
    ad: {
      title: "Relend Earn",
      subtitle: "Earn stable profits with professional asset management",
      total_borrowed: "Total borrowed",
      apy_fixed_rate: "Borrow APR, fixed rate",
      claim_now: "Claim now",
    },
    modal: {
      supply: "Supply",
      withdraw: "Withdraw",
      repay: "Repay",
      borrow: "Borrow",
      max: "Max",
      balance: "Balance:",
      in_wallet: "in wallet",
      market_price: "Market Price",
      supply_apy: "Supply APY",
      your_supply_limit: "Your max supply limit",
      borrow_utilization: "Borrow Utilization",
      your_total_supply: "Your total supply",
      borrow_apr: "Borrow APR",
      borrow_fee: "Borrow fee",
      your_total_borrow: "Your total borrow",
      your_total_borrow_limit: "Your total borrow limit",
      liquidation_threshold: "Liquidation threshold",
      successfully: "successfully",
      view_transaction: "Click here to view transaction",
      enter_amount: "Enter amount",
      growth_hacking_desc: "This feature is coming soon. Please comeback later!",
      happy_pi_day: "Happy international Pi Day 14/03",
      no_supply_collateral: "You haven't supply any collateral",
      no_supply_reserve: "You haven't supply any %s",
      loading: "Loading...",
      updating: "Updating...",
      supply_apy_tooltip:
        "Supply APY (annual percentage rate) is the rate of return from users who borrow your assets when you supply.  The supply APY is split across the entire pool. For example, if there is 2 BTC in a pool, and 1 BTC is lent out at 20% APY, the suppliers of the 2 BTC will receive 10% APY each",
      borrow_apr_tooltip:
        "Borrow APR is the annual percentage rate that borrowers pay on loans. It is calculated by taking into account the interest rate on the loan",
      borrow_fee_tooltip: "Fee need to pay for protocol when borrowing",
      borrow_utilization_tooltip:
        "Borrow Utilization represents how much of your borrow limit. Utilization is Tokens Borrowed / Tokens Supplied",
      total_borrow_limit_tooltip: "The total money that users can borrow across the platform",
      liquidation_threshold_tooltip:
        "Liquidation threshold is the maximum value of your borrow balance before your account will be eligible for liquidation. This is a costly event and should be avoided by lowering your borrow utilization. This limit is calculated based on your deposits and borrowed amount",
      your_max_supply_tooltip: "The maximum value of tokens that you can supply accross the platform",
      your_total_borrow_tooltip: "The total value of your current  borrowed tokens accross the platform",
      your_total_supply_tooltip: "The total value of your current  supplied tokens accross the platform",
      supply_successfully: "Supply Successfully",
      borrow_successfully: "Borrow Successfully",
      withdraw_successfully: "Withdraw Successfully",
      repay_successfully: "Repay Successfully",
      liquidate_successfully: "Liquidate Successfully",
      you_just_supplied: "You just supplied",
      you_just_borrowed: "You just borrowed",
      you_just_withdrawed: "You just withdrawed",
      you_just_repaid: "You just repaid",
      you_just_liquidated: "You just liquidated",
      view_tx: "View transaction",
      go_home: "Go to home",
      close: "Close",
      free_borrow_fee: "(FREE)",
      borrowed: "borrowed",
      interest_to_pay: "Interest to pay",
      total_amount_repay: (symbol: string) => `Total ${symbol} repay`,
      not_enough_balance: "Not enough balance. View how to deposit",
      not_enough_balance_link: "https://renec.org/blog/how-to-deposit-token",
      not_enough_balance_solana_token_link: (tokenMint: string) =>
        tokenMint === USDC
          ? `https://jup.ag/swap/SOL-USDC`
          : tokenMint === SOL
            ? `https://jup.ag`
            : `https://jup.ag/swap/USDC-${tokenMint}`,
      how_to_withdraw: "How to withdraw VND to your bank account?",
      how_to_withdraw_link: "https://renec.org/blog/guide-to-borrow-repay-revnd",
      withdraw_to_bank: "Withdraw to bank",
      congrats: "Congrats",
      oops: "Oops!",
      ok: "Ok",
      choose_nft_for_promotion: "Choose NFT for promotion",
      select_nft: "Select NFT",
      choose_nft_to_send: "Choose NFT to send",
      choose_nft: "Choose NFT",
      search_by_name_or_address: "Search by name or address",
      change_nft: "Change NFT",
      choose_nft_error: "The NFT could not be applied. Please select a different NFT",
      no_nft_to_send: "No NFT to send",
      nft_address: "Address:",
      nft_promotion: (discount: number, maxDiscount: number) => `Discount ${discount}% - Maximum $${maxDiscount}`,
      nft_detail: "NFT Detail",
      nft_description: "Description",
      nft_more_info: "More info",
      nft_more_info_start_date_end_date: "Start date - end date",
      nft_more_info_discount_percentage: "Discount percentage",
      nft_more_info_eligible_token: "Eligible token",
      nft_more_all_token: "All token",
      show_more: "More info",
      show_less: "Less info",
      claim_your_reward: "Claim your reward",
      claim_your_reward_desc: (symbol: string) => `Would you like to claim all of your ${symbol} rewards?`,
      claim_confirm: "Claim",
      claim_later: "Later",
      confirm: "Confirm",
      claim_successfully: "Successfully",
      you_have_claimed_successfully: (rewardSymbol: string) => (
        <>
          You have claimed all of your{" "}
          <Typography component='span' fontWeight={700}>
            {rewardSymbol}
          </Typography>{" "}
          reward successfully
        </>
      ),
      claim_you_got: "You got",
      claim_nft_voucher: "Claim NFT voucher",
      claim_nft_voucher_desc: "Would you like to claim 1 NFT voucher?",
      claim_nft_voucher_successfully: "You just claimed successfully",
      exclusive_gift_for_you: "Exclusive gift for you",
      exclusive_gift_for_you_desc: (
        <>
          Congratulations! You have received{" "}
          <span className='font-semibold text-base text-[#F7931A]'>an NFT voucher</span>
        </>
      ),
      get_it_now: "Get it now",
      errors: {
        max_positions_reached: "Max number of positions reached",
        over_reserve_deposit_limit: "Reserve deposit limit is reached",
        insufficient_balance: (tokenSymbol?: string) =>
          tokenSymbol ? `Insufficient ${tokenSymbol} balance` : "Insufficient balance",
        min_native_fee: "Please top up %s %s for transaction and rent fee",
        insufficient_renec_balance: "Insufficient RENEC balance to make transaction",
        please_enter_amount: "Please enter amount",
        insufficient_liquidity_borrow: "Insufficient liquidity to borrow",
        over_reserve_borrow_limit: "Reserve borrow limit is reached",
        cannot_borrow_utilization: "Utilization is over 95%. Cannot borrow more",
        exceeds_borrow_limit: "Exceeds borrow limit",
        pool_outflow_rate_limit: "Pool outflow rate limit surpassed",
        reserve_outflow_rate_limit: "Reserve outflow rate limit surpassed",
        insufficient_liquidity_withdraw: "Insufficient liquidity to withdraw",
        cannot_withdraw_limit: "Cannot withdraw more than withdraw limit",
        cannot_withdraw_under_collateralization: "Cannot withdraw because your supply is used as collateralization",
        amount_exceeded_borrowed: "Amount exceeded the amount borrowed",
        failed_to_complete: "Failed to complete transaction",
        please_use_gasless:
          "Min 0.02 RENEC for transaction and rent fees. Please use gasless or deposit more RENEC to make transaction",
        need_renec_for_transaction_fee:
          "You need at least 0.000005 RENEC for transaction fee. Please use gasless or deposit more RENEC to make transaction",
        need_sol_for_transaction_fee:
          "You need at least 0.02 SOL for transaction and other fee. Please deposit more SOL to make transaction",
        deposit_more_token: "Deposit more %s",
        deposit_more_renec: "Deposit more RENEC",
        deposit_more_sol: "Deposit more SOL",
        failed_to_liquidate: "Failed to liquidate obligations",
        gasless_updating: "The gasless service is updating. Please use normal transaction",
        reduce_positions:
          "You have reached maximum number of Supply and Borrow positions. Please reduce number of position or use another wallet to supply/borrow this token",
        tx_too_large:
          "Your transaction is too large. Please reduce your supply/borrow positions or switch to another wallet and try again",
        not_enough_ste_fund: "All rewards have been claimmed. Stay tuned with RENEC Lend for upcoming events",
      },
      usds_notice: {
        title: "USDS Withdrawal Notice",
        message:
          "Please note that withdrawals made before 04/01/2025 will only include the deposited USDS. Rewards will be accessible for withdrawal after 04/01/2025.",
      },
    },
  },
  referral: {
    empty: {
      not_qualified: "You don't have any Relend token to be qualified",
      please_buy_rel: "Please buy Relend token to continue",
      buy_rel: "Buy REL",
    },
    hero: {
      title: "Refer your friend and earn rewards",
      sub_title: "Invite your friends to join us, and both of you can enjoy exclusive benefits.",
      connect_wallet: "Connect Wallet",
      copy_link: "Copy link",
      copied: "Copied",
      your_referrer: "Your referrer",
      view_detail: "View detail",
    },
    detail: {
      title: "Referral program details",
      desc_1: "To qualify, hold REL tokens, connect your wallet, and share your referral link",
      desc_2: "When a new user connects their wallet to RENEC Lend with your link, they will be marked as your referee",
      desc_3:
        "After that, whenever your referee borrows, you will receive 20% of the borrow fees they pay, at no extra cost to them",
      overview: "Overview",
      bonus_you_got: "The bonus you got",
      have_been_invited: "Total friends you invited",
      friends: "Friends",
      no_bonus: "No bonuses",
      borrow_now: "Borrow Now",
      connect_wallet_to_view: "Connect wallet to view all your bonus!",
      detail: "Details:",
      how_to_refer: "How to refer",
      show_more: "Show more",
      show_less: "Show less",
    },
    table: {
      reward_history: "Reward History",
      timestamp: "Timestamp",
      referred: "Referred",
      asset: "Asset",
      reward_earned: "Reward Earned",
      tx_detail: "Txn Details",
      no_data: "No Data",
      load_more: "Load more",
    },
  },
  liquidations: {
    liquidation_position: "Liquidation positions",
    choose_position_liquidate: "Choose the active position to liquidate the loan",
    table: {
      position_id: "Position ID",
      loan_token: "Loan token",
      collateral_token: "Collateral token",
      collateral_amount: "Collateral amount",
      need_to_pay: "Need to pay",
      liquidate: "Liquidate",
      actions: "Actions",
    },
  },
  staking: {
    hero: {
      stake_earn_grow: "Stake & Earn: grow your",
      craft_your: "Crafting Your",
      relend: "Relend",
      rel: "REL",
      shape_future: ", shape the future.",
      rel_holders: "REL holders",
      description:
        "can stake their assets in the Secure Vault to add more security to the protocol and earn rewards. In the case of a shortfall event, RENEC Foundation will borrow an amount from the vault to cover the lost, providing an additional layer of protection for the protocol.",
      learn_more: "Learn more",
      learn_more_link: "https://renec.org/blog/stake-relend-feature",
      total_staked_rel: "Total REL in Secure Vault",
      total_reward_per_day: "Total reward per day",
      total_reward_per_day_tooltip: "The total reward will be distributed daily to all Relend stakers",
      staking_apy: "Staking APY",
    },
    detail: {
      my_assets: "My Assets",
      my_staking_reward: "My Staking Reward",
      rel_wallet_balance: "REL wallet balance",
      your_verel: "veREL wallet balance",
      stake: "Stake",
      unstake: "Unstake",
      start_unstake: "Start Unstake",
      withdraw: "Withdraw",
      convert: "Convert",
      my_rel_staking: "My REL Staking",
      total_staked_rel: "Total Staked REL",
      cooldown_period: "Cooldown period",
      total_claimable_verel: "Total Claimable veREL",
      unstaking: "unstaking",
      stop_unstake: "Stop Unstake",
      claim: "Claim",
      what_is_verel: "What is veREL?",
      what_is_verel_link: "https://renec.org/blog/stake-relend-feature",
      cooldown_tooltip_1:
        "When users unstake, the cooldown period will be activated. The duration will based on the amount of unstaked REL:",
      cooldown_tooltip_2: "Less than 1,000,000 REL: 7 days (168 hours)",
      cooldown_tooltip_3: "Equal or More than 1,000,000 REL: 14 days (336 hours)",
      cooldown_tooltip_4:
        "When in cooldown period, users still can stake more REL and at that time, the unstake process will be cancelled.",
      connect_wallet_to_view_reward: "Connect wallet to view all your reward!",
    },
    modal: {
      staking: "Staking",
      unstaking: "Unstaking",
      estimate_reward: "Estimate your reward per day",
      staking_apy: "Staking APY",
      estimate_cooldown: "Estimate your cooldown period",
      days: "days",
      hours: "hours",
      stake: "Stake",
      unstake: "Unstake",
      are_you_sure: "Are you sure you want to claim",
      are_you_sure_stop_unstake: "Are you sure you want to stop unstaking",
      stop_unstaking: "Stop unstaking",
      cancel: "Cancel",
      claim: "Claim",
      stop: "Stop",
      withdraw: "Withdraw",
      in_wallet: "in wallet",
      staked: "staked",
      just_staked: "You just staked successfully.",
      just_start_unstaking: "You just started unstaking successfully.",
      stop_unstaking_token_successfully: "You just stop unstaking successfully.",
      claim_reward_token_successfully: "You just claimed reward token successfully.",
      stake_successfully: "Stake Successfully",
      unstake_successfully: "Unstake Successfully",
      stop_unstaking_successfully: "Stop Unstaking Successfully",
      withdraw_successfully: "Withdraw Successfully",
      claim_reward_successfully: "Claim Reward Successfully",
      you_just_staked: "You just staked",
      you_just_unstaked: "You just unstaked",
      you_just_stop_unstaked: "You just stopped unstaking",
      you_just_withdraw: "You just withdrew",
      you_just_claim_reward: "You just claimed",
      confirm: "Confirm",
      claim_verel: "Claim veREL",
    },
    errors: {
      failed_to_fetch_reward_token_account_info:
        "Error when fetching token reward data. Please contact RENEC team for more information or try again.",
      stake: "Error when staking token. Please contact RENEC team for more information.",
      unstake: "Error when start unstaking token. Please contact RENEC team for more information.",
      fetch_bte_reward: "Error when fetching borrow rewards. Please contact RENEC team for more information.",
      please_enter_amount: "Please enter amount",
      not_enough_balance: "Not enough balance",
      cannot_unstake_above_staked_amount: "Cannot unstake above the staked amount",
      withdraw_staking_token:
        "Error when withdrawing staking token. Please contact RENEC team for more information or try again.",
      claim_reward_token:
        "Error when claiming reward token. Please contact RENEC team for more information or try again.",
      stop_unstaking: "Error when stop unstaking. Please contact RENEC team for more information or try again.",
      stake_unstake: "Error when staking/unstaking token. Please contact RENEC team for more information or try again.",
      failed_to_complete: "Failed to complete transaction",
      deposit_more_renec: "Deposit more RENEC",
      please_deposit_renec: "Min %s RENEC for transaction and other fees. Deposit more RENEC to make transaction",
    },
  },
  common: {
    tx_hash: "Tx hash: ",
    sorry_feature_developing: "This feature is currently under development. Please check back later for updates.",
    feature_under_development: "Feature under development",
    ok: "Ok",
    come_back_later: "Come back later",
    search_token: "Search token",
    token_picker_no_tokens_found: "No tokens found",
    token_picker_please_select: "Select token",
    notification: "Notification",
    cancel: "Cancel",
    confirm: "Confirm",
  },
  wallet: {
    copied: "Copied",
    copy_address: "Copy address",
    connect_wallet: "Connect wallet",
    change_wallet: "Change wallet",
    connecting: "Connecting ...",
    select_wallet: "Select Wallet",
    disconnect: "Disconnect",
  },
  errors: {
    go_back_home: "Go back home",
    error_404: "404 - Page Not Found",
    error_500: "500 - Server-side error occurred",
    system_error: "System is updating. Please try again later",
    deny_transaction: "User denied transaction.",
    default_error: "Failed to execute transaction. Please try again later!",
  },
}

export default locale
